import "./Pied2Page.scss";

export default function Pied2Page() {

  return(
    <footer className="Pied2Page">
        {new Date().getFullYear()} - Noémie da Silva - 4PA - TIM
      </footer>
  ) 
}